/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import EmailOutlineIcon from 'mdi-react/EmailOutlineIcon';
import { Button } from 'reactstrap';
import getPicture from '../../../shared/functions/getPicture';
import { subscribeUnread, formatUnread } from '../../../shared/functions/unreadPoller';
import { unseenMessages } from '../../../shared/functions/feedKinds';
import trackEvent from '../../../shared/functions/trackEvent';

const messagesIcon = `${process.env.PUBLIC_URL}/img/messages.svg`;

export default class TopbarMail extends PureComponent {
  state = {
    unread: 0,
    collapse: false,
    notifications: [],
    unseenByKind: {},
  };

  componentDidMount = () => {
    this.unsubscribe = subscribeUnread(({ messages, unreadMessages, unseenByKind }) => {
      this.setState({ notifications: messages, unread: unreadMessages, unseenByKind });
    });
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) this.unsubscribe();
  };

  // Each opening is tracked with the label that was showing, closing is not.
  toggle = () => {
    const { collapse, unseenByKind } = this.state;
    if (!collapse) {
      const label = unseenMessages(unseenByKind);
      trackEvent('mail_opened', { label: label ? label.kind : 'none', count: label ? label.count : 0 });
    }
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  render() {
    const {
      collapse, notifications, unread, unseenByKind,
    } = this.state;
    // New messages since the notification center was opened pulse on the icon.
    const label = unseenMessages(unseenByKind);
    return (
      <div className="topbar__collapse">
        <button
          className={`topbar__btn topbar__btn--mail topbar__btn--new${label
            ? ' topbar__btn--labelled topbar__btn--pulse' : ''}`}
          type="button"
          onClick={this.toggle}
        >
          <div className="topbar__btn-icon-wrapper">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18" cy="18" r="17.5" stroke="#8D9AA1" fill="none" />
            </svg>
            <img
              src={messagesIcon}
              alt="notifications"
              className="topbar__btn-icon-image"
            />
          </div>


          {unread > 0
            && <span className="topbar__btn-count">{formatUnread(unread)}</span>
          }
          {label && <span className="topbar__btn-label topbar__btn-label--message">{label.text}</span>}
        </button>
        {
          collapse
          && (
            <>
              <button className="topbar__back" type="button" onClick={this.toggle} />
              <span className="topbar__collapse-arrow" />
              <div className="topbar__collapse-content">
                <div className="topbar__collapse-title-wrap">
                  <p className="topbar__collapse-title">Unread messages</p>
                </div>
                {notifications.length === 0
                  && (
                    <div className="topbar__collapse-empty">
                      <EmailOutlineIcon />
                      <p className="topbar__collapse-empty-title">No messages yet</p>
                      <p className="topbar__collapse-empty-text">
                        This is where your conversations with investors and founders live. Check back often so you
                        can answer quickly: replies sent within a day are the ones that turn into meetings.
                      </p>
                    </div>
                  )
                }
                {notifications.map((notification, index) => (
                  <>
                    <div
                      className="topbar__collapse-item-divider
                      d-flex flex-row align-items-center justify-content-center"
                    >
                      <svg
                        width="221"
                        height="2"
                        viewBox="0 0 221 2"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 1C10.5 1 220.5 1 220.5 1" stroke="#EDEFF2" />
                      </svg>
                      <span className="topbar__collapse-date">
                        {notification.date}
                      </span>
                    </div>
                    <Link
                      className="topbar__collapse-item"
                      key={index}
                      to={`/inbox/${notification.conv_id}`}
                      onClick={this.toggle}
                    >
                      <div className="topbar__collapse-img-wrap">
                        <img
                          className="topbar__collapse-img"
                          src={getPicture(notification)}
                          alt="pic"
                        />
                      </div>
                      <div>
                        <p className="topbar__collapse-name">{notification.name}</p>
                        <p className="topbar__collapse-message topbar__collapse-message--mail">
                          {notification.message}
                        </p>
                      </div>
                    </Link>
                  </>
                ))}
                <Link to="/inbox" onClick={this.toggle}>
                  <Button
                    className="rounded icon icon--right icon--blue topbar__action-btn mb-3 mt-2"
                    color="primary"
                    size="sm"
                  >
                    See all messages <ChevronRightIcon />
                  </Button>
                </Link>
              </div>
            </>
          )
        }
      </div>
    );
  }
}
